import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import { ITransmissionTypesResponseSchema } from "./transmissionTypesAPI.types";

const getAllTransmissionTypesAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<ITransmissionTypesResponseSchema[]> =>
  handleGlobalGetRequestQuery({
    url: URLS.TRANSMISSION_TYPE,
    searchParams,
    signal,
  });

const getSingleTransmissionTypesAPI = (
  id: string
): Promise<{ data: ITransmissionTypesResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.TRANSMISSION_TYPE}/${id}`,
  });

export { getAllTransmissionTypesAPI, getSingleTransmissionTypesAPI };
